import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv1 = () => {
  return <header className="bg-white" data-id="element-17006" data-mp="o6yhhr1qgssx">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17007" data-mp="t4qidakcvp99"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17008" data-mp="x6va23r8ubt9">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17009" data-mp="x4qu2ng2lmcm">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17010" data-mp="124wtipsl0d59">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17011" data-mp="172ogr6ia7b34">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-17012" data-mp="1gu18zz7zs39o">
          <div className="text-xs text-gray-400 font-sans" data-id="element-17013" data-mp="1kwxwa38h8njy">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17014" data-mp="1pv95cbqy6u14">
          <div className="text-left" data-id="element-17015" data-mp="2falxf5ql77j1">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17016" data-mp="2b7z0wriz0yfi">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17017" data-mp="2txx5uyrh2bex">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17018" data-mp="2p5njfspkfthe">
        <div className="max-w-4xl mx-auto" data-id="element-17019" data-mp="2k7udn0s6d1hn">
          <div className="flex items-center text-xs text-gray-500 mb-4 border-b border-gray-200 pb-2" data-id="element-17020" data-mp="2k6szgnfv3yvp">
            <div className="flex items-center mr-4" data-id="element-17021" data-mp="3cxb2xpki029n">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-17022" data-mp="3cwj9oledigmj" />
              <span data-id="element-17023" data-mp="1b00xfj7ttuo7">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-17024" data-mp="1b1vg0qvmlap4">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-17025" data-mp="1f1m4up1ldgr0" />
              <span data-id="element-17026" data-mp="1f36zsfrtj1pe">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17027" data-mp="ibvaqqx7pvlq">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17028" data-mp="2cp4mkpd8dt75">
            73-Year-Old Corning Engineer Exposes Why All Grounding Sheets Fail —
            Then Builds Ones That Don't
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17029" data-mp="2rt7e3nqw4ihn">
            How submarine cable technology and $388,716 in retirement savings
            led to the only grounding sheets that still work after 1,000 washes
          </p>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17030" data-mp="2vsojkh6bhfmt">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17031" data-mp="3ahujk7czb9vr">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-17032" data-mp="35ihmktse8mfg" />
            </div>
            <div className="flex-1" data-id="element-17033" data-mp="3fhgxkj0msu5m">
              <div className="flex items-center" data-id="element-17034" data-mp="3fii6ohy376kp">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17035" data-mp="1p4rg5gdsxm2n">
                  By Tom Davidson
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17036" data-mp="1l50t9nrebq3e">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17037" data-mp="1mlebxppqbkuq" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17038" data-mp="1mmz63e84t1s2">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17039" data-mp="1rlshn13uyipl">
                Retired Electrical Engineer, Corning Inc. | As told to
                Traditional Medicine Publications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17040" data-mp="13uddr3wfntc8">
                <div className="flex items-center mr-4" data-id="element-17041" data-mp="13w7yoi7pflgb">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17042" data-mp="17v72u0lm3e6p" />
                  <span data-id="element-17043" data-mp="17tm6q6jnfn6q">9 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17044" data-mp="1cu9w6ns8bvyu">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17045" data-mp="1hlrxjcy5zykc" />
                  <span data-id="element-17046" data-mp="1hncsv4sazlj9">18,342 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5" data-id="element-17047" data-mp="k64de6kqkh1n">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/232sjW71qLLR3zci5F48Jb/1_Tom_Davidson.png" alt="Tom Davidson working at his desk with engineering equipment" className="w-full rounded-lg shadow-md" data-id="element-17048" data-mp="p57ghlh5od6z" />
          </div>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17049" data-mp="co6gd1jqqyfb">
            <div className="mb-1 flex items-center" data-id="element-17050" data-mp="7m7a9jwm9neo">
              <span className="font-medium mr-2" data-id="element-17051" data-mp="3mgmlp2dzned">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17052" data-mp="3ut9qj0oke0ml">
              <span className="font-medium mr-2" data-id="element-17053" data-mp="3q1rkvzbljbva">Published:</span>
              November 2025
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv1;